module.exports = __webpack_public_path__ + "static/media/0_2018_09_24-2.3885728f.jpg";